import { STATE_LIST } from "@vahak/core/dist/constants/StateList";

export interface LoadRouteLocationFields {
    source?: string;
    source_city_name?: string;
    source_state_id?: number;
    source_state_name?: string;
    destination?: string;
    destination_city_name?: string;
    destination_state_id?: number;
    destination_state_name?: string;
}

export interface LoadRouteLocationDisplay {
    sourceCity?: string;
    sourceState?: string;
    destinationCity?: string;
    destinationState?: string;
}

export const getStateCodeById = (stateId?: number) => STATE_LIST.find((state) => state.id === stateId)?.code;

function getCityFallback(cityName?: string, routeLabel?: string) {
    if (cityName?.trim()) {
        return cityName.trim();
    }

    const [firstPart] = (routeLabel || "").split(",");
    return firstPart?.trim() || routeLabel?.trim() || undefined;
}

export function getRouteLocationDisplay(loadDetail?: LoadRouteLocationFields): LoadRouteLocationDisplay {
    if (!loadDetail) {
        return {};
    }

    return {
        sourceCity: getCityFallback(loadDetail.source_city_name, loadDetail.source),
        sourceState: getStateCodeById(loadDetail.source_state_id) || loadDetail.source_state_name,
        destinationCity: getCityFallback(loadDetail.destination_city_name, loadDetail.destination),
        destinationState: getStateCodeById(loadDetail.destination_state_id) || loadDetail.destination_state_name
    };
}
